import React from "react"
import './style.scss'
import LogoutLink from "../LogoutLink"


export default class Dropdown extends React.Component {
  constructor() {
    super();

    this.state = {
      displayMenu: false
    };

    this.showDropdownMenu = this.showDropdownMenu.bind(this);
    this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
  }

  showDropdownMenu(event) {
    event.preventDefault();
    this.setState({ displayMenu: true }, () => {
      document.addEventListener("click", this.hideDropdownMenu);
    });
  }

  hideDropdownMenu() {
    this.setState({ displayMenu: false }, () => {
      document.removeEventListener("click", this.hideDropdownMenu);
    });
  }

  render() {
    const {items} = this.props

    return (
      <div className="mabna-dropdown">
        <div className="button" onClick={this.showDropdownMenu}>
          <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
        </div>

        {this.state.displayMenu ? (
          <ul>
            {items.length > 0 && items.map( (item, index) => {
              return <li key={index}>{item}</li>
            })}
          </ul>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Dropdown/Dropdown.js